import { type AdminRoute } from './AdminRoute';

export const getRoutePath = (route: AdminRoute | string) => `/${route}`;
